// @flow
import * as React from "react";
import makesInvoblox from "../../../images/homeNew/modernStack.mp4";
import * as style from "./style.module.scss";

const MakeIbVideo = () => {
  return (
    <div>
      <video
        playsInline
        className={style.video}
        loop={true}
        muted
        autoPlay={true}
        src={makesInvoblox}
      >
        <track kind="captions" src="" />
      </video>
    </div>
  );
};

export default MakeIbVideo;
